import { useEffect, useState } from 'react';

import StaticAdsService from 'services/StaticAdsService';

import formatEnumLabel from './formatEnumLabel';

/**
 * Format keys resolved to the names the picker offers.
 *
 * A chip must read as the name the operator chose ("Big Headline", not
 * "Headline"), so the label comes from the same registry the picker lists —
 * 8 of the 15 built-in keys do not reduce to their label.
 *
 * Losing the registry costs the nicer label and nothing else, so this never
 * blocks a render; it is still a real failure, so it is logged rather than
 * passing silently.
 */
export default function useStaticFormatLabels(service: StaticAdsService) {
  const [labels, setLabels] = useState<Record<string, string>>({});

  useEffect(() => {
    let active = true;
    void service.listStaticFormats().then((resp) => {
      if (!active) return;
      if (!resp) {
        console.error('Loading the static format registry failed — chips will show raw keys');
        return;
      }
      setLabels(Object.fromEntries((resp.formats || []).map(f => [f.key, f.label])));
    });
    return () => { active = false; };
  }, [service]);

  return (key?: string | null): string => {
    const value = typeof key === 'string' ? key.trim() : '';
    if (!value) return '';
    return labels[value] || formatEnumLabel(value);
  };
}
